<template>
  <v-expansion-panel>
    <v-expansion-panel-header>{{dayName}}</v-expansion-panel-header>
    <v-expansion-panel-content>
        <v-data-table
        dense
        :headers="headers"
        :items-per-page="35"
        :items="dayParts"
        :hide-default-header="$vuetify.breakpoint.smAndDown"
        hide-default-footer
        no-data-text="No Schedule Selected"
        item-key="id">
        <template v-slot:top>
            <v-toolbar flat color="white" height="0">
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" >
                <!-- <template v-if="dayName != 'Monday'"  v-slot:activator="{ on }">
                  <v-btn v-on="on" color="primary" dark @click.prevent="addDayPart()" height="20" :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;margin-top: -67px;margin-right: 20px;':'font-size:0.650rem; margin-top: -30px;'" tile :disabled="!selectedSchedule"><v-icon size="15">add</v-icon>Day Part</v-btn>
                </template> -->
                <v-card flat min-height="300">
                <v-card-title>{{cardTitle}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text :style="editedItem.event_type?'':'min-height: 280px;'">
                    <v-container >
                    <v-form ref="form">
                    <v-row>
                        <v-col cols="12">
                        <label>{{editedItem.event_type?'Start Time':'Close Time'}}</label>
                            <vue-timepicker 
                            hour-label=" " 
                            minute-label=" "
                            apm-label=" "
                            :hide-clear-button="showCloseBtn"
                            :blur-delay="1800"
                            auto-scroll
                            input-width="100%" 
                            v-model="editedItem.start_time" 
                            format="hh:mm A"
                            @input="timeValidate"></vue-timepicker>
                        <div v-if="isValidDayPart" class="v-messages theme--light error--text mt-2" role="alert">
                            <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{dayPartValidationMsg}}</div>
                            </div>
                        </div>
                        </v-col>
                        <v-col cols="12" v-if="editedItem.event_type">
                        <v-autocomplete
                            prepend-icon="radio"
                            class="mt-2"
                            label="Choose a channel"
                            autocomplete="off"
                            :items="channels"
                            item-text="name"
                            v-model="selectedChannel"
                            return-object
                            :rules="channelRules"
                            @change="channelChanged"
                        >
                        <template v-slot:selection="data">
                            ({{data.item.channel_number}}) {{data.item.name}}
                        </template>
                        <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                            <v-list-item-content>({{data.item.channel_number}}) {{data.item.name}}</v-list-item-content>
                            </template>
                        </template>
                        </v-autocomplete>
                        </v-col>
                        <v-col cols="12" v-if="editedItem.event_type">
                        <v-text-field
                        prepend-icon="volume_down" 
                        append-icon="volume_up"
                        @click:append="volumeUp"
                        @click:prepend="volumeDown"
                        v-model="editedItem.volume"
                        :rules="volumeRules"
                        label="Volume"></v-text-field>
                        </v-col>

                        <v-col cols="12" v-if="editedItem.event_type">
                        <v-autocomplete
                        prepend-icon="radio"
                        class="mt-2"
                        label="Choose a message playlist"
                        autocomplete="off"
                        :items="playlists"
                        item-text="name"
                        v-model="selectedPlaylist"
                        return-object
                        :rules="channelRules"
                        @change="playlistChanged"
                        >
                        <template v-slot:selection="data">
                            ({{data.item.duration?data.item.duration:'0'}}) {{data.item.name}}
                        </template>
                        <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                            <v-list-item-content>({{data.item.duration?data.item.duration:'0'}}) {{data.item.name}}</v-list-item-content>
                            </template>
                        </template>
                        </v-autocomplete>
                        </v-col>
                        <v-col cols="12" v-if="editedItem.event_type">
                        <v-text-field
                        prepend-icon="volume_down" 
                        append-icon="volume_up"
                        @click:append="volumeUp2"
                        @click:prepend="volumeDown2"
                        v-model="editedItem.volume2"
                        :rules="volumeRules"
                        label="Volume"></v-text-field>
                        </v-col>
                    </v-row>
                    </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="editedItem.event_type?save(1):save(0)" :disabled="isValidDayPart">Save</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:[`item.day_part`]="{ item }">
            <v-chip
            small
            color="green"
            v-if="dayParts.map(function(x) {return x.id; }).indexOf(item.id) == 0" style="color: #fff;">
            Open
            </v-chip>
            <v-chip 
            small
            color="red"
            v-else-if="dayParts.map(function(x){return x.id;}).indexOf(item.id) === dayParts.length - 1 && item.event_type == 0" style="color: #fff;">
            Closed
            </v-chip>
            <v-chip
            small 
            color="red"
            v-else-if="item.channel == 0 && item.playlist_name == null" style="color: #fff;">
            Day Part {{dayParts.map(function(x) {return x.id; }).indexOf(item.id) }}
            </v-chip>
            <v-chip
            small
            color="primary"
            v-else>
            Day Part {{dayParts.map(function(x) {return x.id; }).indexOf(item.id) }}
            </v-chip>
        </template>
        <template v-slot:[`item.start_time`]="{ item }">
          <span>{{ getFormatedTime(item.start_time) }}</span>
        </template>
        <template v-slot:[`item.name`]="{ item }">
           <p v-if="item.channel==0 && item.event_type != 0 && item.playlist_name == null">(0) Stop Playing</p>
           <p v-else-if="item.playlist_name !=  null">Playlist Enabled.</p>
            <p
            v-else-if="dayParts.map(function(x){return x.id;}).indexOf(item.id) === dayParts.length - 1">
            *Stops the audio stream until the next opening
            </p>
            
            <p v-else>({{item.channel_number}}) {{item.name}}</p>
        </template>

        <template v-slot:[`item.volume`]="{ item }">
            <p
            v-if="dayParts.map(function(x){return x.id;}).indexOf(item.id) != dayParts.length - 1">
            {{parseInt(item.volume)+ '%'}}
            </p>
        </template>
        <template v-slot:[`item.volume2`]="{ item }">
            <p>
            {{parseInt(item.volume2)+ '%'}}
            </p>
        </template>
        <template v-slot:[`item.action`]="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item,dayParts,2)">
            edit
            </v-icon>
            <v-icon
            small
            v-show="item.event_type"
            @click="deleteItem(item)">
            delete
            </v-icon>
        </template>
        </v-data-table>
        <div v-if="scheduleName == ''">
        <v-btn 
        color="primary" 
        dark @click.prevent="addDayPart()" 
        height="20" 
        :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;float:right; margin-right:10px;':'font-size:0.650rem;float:right;'" 
        :disabled="!selectedSchedule" 
        tile>
            <v-icon size="15">add</v-icon>Day Part
        </v-btn>
        <v-btn 
        v-if="dayParts.length > 0"
        color="primary" 
        dark height="20" 
        :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;margin-right: 10px;float:right;':'font-size:0.650rem;float:right;margin-right: 10px;'" 
        tile @click.prevent="copyToAllDays" 
        :disabled="!selectedSchedule"><v-icon size="15">add</v-icon>Copy to all days</v-btn>
        </div>
        <div v-else>
        <v-btn 
          color="primary" 
          dark @click.prevent="addDayPart()" 
          height="20" 
          :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;float:right; margin-right:10px;':'font-size:0.650rem;float:right;'" 
          :disabled="!isValidForm" 
          tile>
          <v-icon size="15">add</v-icon>Day Part
        </v-btn>
        <v-btn 
        v-if="dayParts.length > 0"
        color="primary" 
        dark height="20" 
        :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;margin-right: 10px;float:right;':'font-size:0.650rem;float:right;margin-right: 10px;'" 
        tile @click.prevent="copyToAllDays" 
        :disabled="!isValidForm"><v-icon size="15">add</v-icon>Copy to all days</v-btn>
        </div>

      <v-dialog 
            max-width="400"
            v-model="deleteDialog">
            <v-card tile>
                <v-card-title>Are you sure?</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                    <p class="title">You want to delete this day part?</p>
                    <div v-if="shouldDeleteItem" class="user-info">
                        <p class="mb-1">Start Time : {{shouldDeleteItem.start_time}}</p>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.prevent="deleteDialogClose" tile >No</v-btn>
                    <v-btn color="red accent-4" @click.prevent="confirmDelete" tile class="white--text">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
    </v-expansion-panel-content>
    </v-expansion-panel>

</template>
<script>
import axios from './../../../axios'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
    props:[
      'dayParts',
      'dayName',
      'selectedSchedule', 
      'channels',
      'dow',
      'getScheduleSettings', 
      'isValidForm', 
      'scheduleName',
      'playlists'
    ],
    data(){
        return {
            showCloseBtn:true,
            isValidChannel: false,
            channelValidationMsg: 'You can\'t add stop playing at the begining of the day.',
            dialog:false,
            deleteDialog: false,
            cardTitle: 'Add Day Part',
            isValidDayPart: false,
            dayPartValidationMsg:'Day part already exists.',
            selectedChannel:null,
            selectedPlaylist:null,
            shouldDeleteItem:null,
            editedIndex:-1,
            editedItem: {
                command: '',
                channel: 0,
                volume: '100%',
                volume2: '100%',
                dow: 0,
                name:'',
                repeat:0,
                url:'',
                start_time:'09:00 AM',
                end_time:'',
                created_at:'',
                updated_at:'',
                id:null,
                event_type:1
                },
            defaultItem: {
                command: '',
                channel: 0,
                volume: '100%',
                volume2: '100%',
                dow: 0,
                name:'',
                repeat:0,
                url:'',
                start_time:'09:00 AM',
                end_time:'',
                created_at:'',
                updated_at:'',
                id:null,
                event_type:1
            },
            channelRules: [
                    v => !!v || 'Channel is required',
                ],
            timeRules: [
                    v => !!v || 'Time is required',
                ],
            volumeRules: [
                    v => !!v || 'Volume is required',
                ],
        }
    },
    methods:{
        channelChanged(){
          if(this.dayParts.length == 0 && this.selectedChannel.id == 0){
            this.isValidChannel = true
          }else{
            this.isValidChannel = false
          }

          if(this.selectedChannel.id == -2){
            this.editedItem.volume = '0%'
          }

        },
        playlistChanged(){
          if(this.selectedPlaylist.id == -2){
            this.editedItem.volume2 = '0%'
          }
        },
        addDayPart(){
            this.cardTitle = 'Add Day Part'
            this.editedItem = Object.assign({}, this.defaultItem)
            this.isValidDayPart = false
            this.dialog = true
            if(this.dayParts.length > 1){
                this.editedItem.start_time = this.nextStartTime(this.getFormatedTime(this.dayParts[this.dayParts.length - 2].start_time))
            }else{
                this.editedItem.start_time = '09:00 AM'
            }
        },
        timeValidate(event){
          let lastDayPart = this.dayParts[this.dayParts.length - 2]
          let openDayPart = this.dayParts[0]
          let closeDayPart = this.dayParts[this.dayParts.length - 1]
          let eventAP = event.split(' ')[1]

          // Wordking with close event ---
          if(lastDayPart && this.editedItem.event_type == 0){

            //Check if a day part exists
            let found = this.dayParts.filter(r=>{
              return this.getFormatedTime(r.start_time) == event && r.event_type != 0 && r.id != this.editedItem.id
            })
            if(found.length > 0){
              this.isValidDayPart = true
              this.dayPartValidationMsg = 'Day part already exists'
              return
            }else{
              this.isValidDayPart = false
            }
            //End global check
            
            let lastDayPartAP = this.getFormatedTime(lastDayPart.start_time).split(' ')[1]
            
            let lastEventTime = parseFloat(this.getFormatedTime(lastDayPart.start_time).split(' ')[0].replace(':','.'))
            let closeEventTime = parseFloat(event.split(' ')[0].replace(':', '.'))

            //Working with close event is done
            if(lastDayPartAP == 'PM' && eventAP == 'AM'){
              this.isValidDayPart = true
              this.dayPartValidationMsg = 'Close event can\'t be a before '+this.getFormatedTime(lastDayPart.start_time)
              return
            }else if(lastDayPartAP == 'AM' && eventAP == 'AM'){
              if(closeEventTime >= 12){
                closeEventTime -= 12
              }

              if(closeEventTime < lastEventTime){
                this.isValidDayPart = true
                this.dayPartValidationMsg = 'Close event can\'t be a before '+this.getFormatedTime(lastDayPart.start_time)
                return 
              }

            }else if(lastDayPartAP == 'PM' && eventAP == 'PM'){

              if(closeEventTime >= 12){
                closeEventTime -= 12
              }

              if(lastEventTime >= 12){
                lastEventTime -= 12
              }

              if(closeEventTime < lastEventTime){
                this.isValidDayPart = true
                this.dayPartValidationMsg = 'Close event can\'t be a before '+this.getFormatedTime(lastDayPart.start_time)
                return 
              } 
            }
          }

          //Open new day part-----
          if(this.editedIndex == -1 && closeDayPart && openDayPart){
            let openDayPartAP = this.getFormatedTime(openDayPart.start_time).split(' ')[1]
            let openDayPartTime = parseFloat(this.getFormatedTime(openDayPart.start_time).split(' ')[0].replace(':','.'))
            let eventTime = parseFloat(this.getFormatedTime(event).split(' ')[0].replace(':', '.'))
            let closeDayPartAP = this.getFormatedTime(closeDayPart.start_time).split(' ')[1]
            let closeDayPartTime = parseFloat(this.getFormatedTime(closeDayPart.start_time).split(' ')[0].replace(':', '.'))

            let found = this.dayParts.filter(r=>{
            return this.getFormatedTime(r.start_time) == event && r.event_type != 0 && r.id != this.editedItem.id
            })
            if(found.length > 0){
              this.isValidDayPart = true
              this.dayPartValidationMsg = 'Day part already exists'
              return
            }else{
              this.isValidDayPart = false
            }

            if(eventAP == 'AM' && openDayPartAP == 'PM' && closeDayPartAP == 'PM'){         
                  this.isValidDayPart = true
                  this.dayPartValidationMsg = 'You can only add a day part between open and closed event.'
                  return 
            }else if(eventAP == 'PM' && openDayPartAP == 'AM' && closeDayPartAP == 'AM'){
                this.isValidDayPart = true
                this.dayPartValidationMsg = 'You can only add a day part between open and closed event.'
                return 
            }else if(openDayPartAP == 'AM' && closeDayPartAP == 'PM'){

              if(eventAP == 'AM'){  
                
                if(eventTime >= 12){
                  eventTime -= 12
                }
                let odt = openDayPartTime
                if(parseInt(openDayPartTime) == 12){
                  openDayPartTime -= 12
                }
                
                if(eventTime < openDayPartTime){

                  this.isValidDayPart = true
                  this.dayPartValidationMsg = 'You can\'t add a day part before '+odt+ ' '+openDayPartAP
                  return 
                }

              }else if(eventAP == 'PM'){

                if(eventTime >= 12){
                  eventTime -= 12
                }

                if(eventTime > closeDayPartTime){
                  this.isValidDayPart = true
                  this.dayPartValidationMsg = 'You can\'t add a day part after '+closeDayPartTime + ' ' + closeDayPartAP
                }

              }

            }else if(openDayPartAP == 'AM' && closeDayPartAP == 'AM'){
              if(eventAP == 'PM'){
                this.isValidDayPart = true
                this.dayPartValidationMsg = 'You can\'t add a day part after '+ closeDayPartTime + ' ' + closeDayPartAP
                return
              }
              
              if(eventAP == 'AM'){
                if(eventTime >= 12){
                  eventTime -= 12
                }
                let odt = openDayPartTime
                if(parseInt(openDayPartTime) == 12){
                  openDayPartTime -= 12
                }

                if(eventTime < openDayPartTime){
                  this.isValidDayPart = true
                  this.dayPartValidationMsg = 'You can\'t add a day part before '+ odt + ' '+ openDayPartAP
                  return 
               }

                if(eventTime >= closeDayPartTime){
                  this.isValidDayPart = true 
                  this.dayPartValidationMsg = 'You can\'t add a day part after '+ closeDayPartTime + ' ' + closeDayPartAP
                  return 
                }

              }
            }else if(openDayPartAP == 'PM' && closeDayPartAP == 'PM'){

              if(eventAP == 'AM'){
                this.isValidDayPart = true
                this.dayPartValidationMsg = 'You can\'t add a day part before '+ openDayPartTime + ' ' + openDayPartAP
                return
              }
              
              if(eventAP == 'PM'){
                if(eventTime >= 12){
                  eventTime -= 12
                }

                if(eventTime < openDayPartTime){
                  this.isValidDayPart = true
                  this.dayPartValidationMsg = 'You can\'t add a day part before '+ openDayPartTime+ ' '+ openDayPartAP
                  return 
               }

                if(eventTime >= closeDayPartTime){
                  this.isValidDayPart = true 
                  this.dayPartValidationMsg = 'You can\'t add a day part after '+ closeDayPartTime + ' ' + closeDayPartAP
                  return 
                }

              }
            }
          }

          //Edit day part-----
          if(this.editedIndex > -1 && closeDayPart && openDayPart && this.editedItem.event_type != 0){
            
            let openDayPartAP = this.getFormatedTime(openDayPart.start_time).split(' ')[1]
            let openDayPartTime = parseFloat(this.getFormatedTime(openDayPart.start_time).split(' ')[0].replace(':','.'))
            let eventTime = parseFloat(this.getFormatedTime(event).split(' ')[0].replace(':', '.'))
            let closeDayPartAP = this.getFormatedTime(closeDayPart.start_time).split(' ')[1]
            let closeDayPartTime = parseFloat(this.getFormatedTime(closeDayPart.start_time).split(' ')[0].replace(':', '.'))
            // console.log(this.editedIndex + ' ' + openDayPartTime + ' ' + eventTime + ' ' + closeDayPartTime)
            let found = this.dayParts.filter(r=>{
              return this.getFormatedTime(r.start_time) == event && r.id != this.editedItem.id
            })
            if(found.length > 0){
              this.isValidDayPart = true
              this.dayPartValidationMsg = 'Day part already exists'
              return
            }else{
              this.isValidDayPart = false
            }

            if(eventTime >= 12 && eventAP == 'AM'){
              eventTime -= 12
            }

            if(eventAP == 'PM' && eventTime < 12){
              eventTime += 12
            }

            if(closeDayPartAP == 'PM' && closeDayPartTime < 12){
              closeDayPartTime += 12
            }


            if(this.editedItem.id == openDayPart.id){
              let secondDayPart = this.dayParts[1]
              let secondDayPartAP = this.getFormatedTime(secondDayPart.start_time).split(' ')[1]
              let secondDayPartTime = parseFloat(this.getFormatedTime(secondDayPart.start_time).split(' ')[0].replace(':', '.'))
              if(eventTime >= 12 && eventAP == 'AM'){
                eventTime -= 12
              }

              if(secondDayPartAP == 'PM' && secondDayPartTime < 12){
                secondDayPartTime += 12
              }

              if(eventTime > secondDayPartTime){
                this.isValidDayPart = true
                this.dayPartValidationMsg = 'Open day part must be a before '+ secondDayPartTime + ' ' + secondDayPartAP
                return
              }

            }

            if(this.editedItem.id != openDayPart.id){
              let odt = openDayPartTime 
              if(parseInt(openDayPartTime) >= 12){
                openDayPartTime -=12
              }
             

              if(eventTime < openDayPartTime){
                this.isValidDayPart = true
                this.dayPartValidationMsg = 'Day part can\'t be a before '+ odt + ' '+ openDayPartAP
                return 
              }

              if(eventTime > closeDayPartTime){
                this.isValidDayPart = true
                let cdt = (closeDayPartTime > 12)?closeDayPartTime-12:closeDayPartTime
                this.dayPartValidationMsg = 'Day part can\'t be a time after '+ cdt + ' ' + closeDayPartAP
                return
              }
            }

          }

        },
        nextStartTime(daytime){

          let newDayTime = this.getFormatedTime(daytime)
          let startTime = newDayTime.split(" ")
          let ampm = startTime[1]
          let fullTime = startTime[0]
          let timeArray = fullTime.split(":")
          let start = parseInt(timeArray[0]) + 1

          if(start == 12){
            start = '12'
            ampm = 'PM'
          }else if(start > 12){
            start = '01'
            ampm = 'PM'
          }

          start = start.toString()
          start = (start.length == 1)? '0'+start:start
          let start_time_full = start+':'+timeArray[1]+ ' ' +ampm
          return start_time_full
        },
        getFormatedTime(time){
          let timeArray = time.split(' ')
          let ampm = timeArray[1]
          let fullTime = timeArray[0]
          let fullTimeArray = fullTime.split(':')
          let hour = fullTimeArray[0]
          let minute = fullTimeArray[1]

          if(parseInt(hour) == 0 && ampm == 'AM'){
            return '12:'+minute+ ' ' + ampm
          }else if(parseInt(hour) == 12 && ampm == 'PM'){
            return '12:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 13 && ampm == 'PM'){
            return '01:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 14 && ampm == 'PM'){
            return '02:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 15 && ampm == 'PM'){
            return '03:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 16 && ampm == 'PM'){
            return '04:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 17 && ampm == 'PM'){
            return '05:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 18 && ampm == 'PM'){
            return '06:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 19 && ampm == 'PM'){
            return '07:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 20 && ampm == 'PM'){
            return '08:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 21 && ampm == 'PM'){
            return '09:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 22 && ampm == 'PM'){
            return '10:'+minute+ ' '+ampm
          }else if(parseInt(hour) == 23 && ampm == 'PM'){
            return '11:'+minute+ ' '+ampm
          }else{
            return time
          }

        },
        editItem(item) {
          this.isValidDayPart = false
          this.cardTitle = this.getDayPartName(item)
          this.editedIndex = this.dayParts.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.editedItem.start_time = this.getFormatedTime(this.editedItem.start_time)
          this.editedItem.volume = parseInt(this.editedItem.volume)+'%'
          this.editedItem.volume2 = parseInt(this.editedItem.volume2)+'%'
          let channel = this.channels.filter(ch=>{return ch.channel_number==item.channel})
          // this.selectedChannel = channel[0].name
          this.selectedChannel = channel[0]

          if(item.playlist_id != 0){
            let playlist = this.playlists.filter(pl=>{
              return pl.id == item.playlist_id
            })
          
            this.selectedPlaylist = playlist[0]
          }

          this.dialog = true
        },
        getDayPartName(item){
          if(this.dayParts.map(function(x){return x.id;}).indexOf(item.id) == 0){
            return 'Open'
          }else if(this.dayParts.map(function(x){return x.id;}).indexOf(item.id) === this.dayParts.length - 1){
            return 'Close'
          }else{
              return 'Day Part ' + this.dayParts.map(function(x) {return x.id; }).indexOf(item.id)
          }
        },
        save(event_type){
            if(!this.$refs.form.validate()) return

            if(this.isValidChannel) return
            
            if (this.editedIndex > -1) {
             
            if(this.selectedChannel.channel_number){
                this.editedItem.channel = this.selectedChannel.channel_number
                this.editedItem.name = this.selectedChannel.name
            }
            
            let modifiedSetting = Object.assign(this.dayParts[this.editedIndex], this.editedItem)
            let formData = {
                start_time: modifiedSetting.start_time,
                channel: (event_type)?this.selectedChannel.channel_number:0,
                volume: parseInt(this.editedItem.volume),
                volume2: parseInt(this.editedItem.volume2),
                schedule_id: this.selectedSchedule,
                playlist_id: this.selectedPlaylist?this.selectedPlaylist.id:0,
                command: (this.selectedChannel.channel_number == 0)?'stop':'play',
                dow: this.dow,
                repeat: 0,
                event_type: event_type
            }

            axios.put('schedule-setting/'+modifiedSetting.id+'?token='+this.$store.getters.getToken,formData)
                .then(response=>{
                  this.$store.dispatch('setAlert', response.data.message)
                  this.getScheduleSettings(0)
                })
                .catch(error=>{
                    this.$store.dispatch('setErrorAlert', error.response.data.message)
                })
            
        } else {
          this.editedItem.name = this.selectedChannel.name
          let formData = {
            start_time: this.editedItem.start_time,
            channel: this.selectedChannel.channel_number,
            volume: parseInt(this.editedItem.volume),
            schedule_id: this.selectedSchedule?this.selectedSchedule:this.$store.getters.getNewScheduleId,
            playlist_id: this.selectedPlaylist?this.selectedPlaylist.id:0,
            schedule:this.scheduleName,
            volume2: parseInt(this.editedItem.volume2),
            command: 'play',
            dow: this.dow,
            repeat: 0,
            event_type: event_type
          }
          // add schedule setting
          if(this.scheduleName == ''){
          axios.post('schedule-setting?token='+this.$store.getters.getToken,formData)
            .then(response=>{
              this.$store.dispatch('setAlert', response.data.message)
              this.getScheduleSettings(0)
            })
            .catch(error=>{
                this.$store.dispatch('setErrorAlert', error.response.data.message)
            })
          }else{
            axios.post('schedule-setting-with-schedule?token='+this.$store.getters.getToken,formData)
              .then(response=>{
                this.$store.dispatch('setScheduleId', response.data.schedule_id)
                this.$store.dispatch('setAlert', response.data.message)
                this.getScheduleSettings(this.$store.getters.getNewScheduleId)
              })
              .catch(error=>{
                  this.$store.dispatch('setErrorAlert', error.response.data.message)
              })
          }
          
           let startTime = formData.start_time.split(" ")
              let ampm = startTime[1]
              let fullTime = startTime[0]
              let timeArray = fullTime.split(":")
              let start = parseInt(timeArray[0]) + 1
              if(start >= 11 && ampm == 'PM'){
                start = '11'
                timeArray[1] = '30'
                ampm = 'PM'
              }
              else if(start == 12){
                start = '12'
                ampm = 'PM'
              }else if(start > 12){
                start = '01'
                ampm = 'PM'
              }

              start = (start.lenght == 1)? '0'+start:start
              let start_time_full = start+':'+timeArray[1]+ ' ' +ampm
              this.defaultItem.start_time = start_time_full
              this.editedItem.start_time = start_time_full
            }
            this.close()
        },
        close(){
            this.dialog = false
            setTimeout(() => {
              this.editedItem = Object.assign({}, this.defaultItem)
              this.editedIndex = -1
              this.selectedChannel = null
              this.selectedPlaylist = null
              this.$refs.form.resetValidation()
            }, 100)
        },
        volumeDown(){
            let v = 0;
            if(parseInt(this.editedItem.volume) > 4){
            v = parseInt(this.editedItem.volume) - 5
            }
            this.editedItem.volume = v+'%'
        },
        volumeUp(){
            let v = 0
            if(parseInt(this.editedItem.volume) < 96){
            v=parseInt(this.editedItem.volume) + 5
            this.editedItem.volume = v+'%'
            }
        },
        volumeDown2(){
            let v = 0;
            if(parseInt(this.editedItem.volume2) > 4){
            v = parseInt(this.editedItem.volume2) - 5
            }
            this.editedItem.volume2 = v+'%'
        },
        volumeUp2(){
            let v = 0
            if(parseInt(this.editedItem.volume2) < 96){
            v=parseInt(this.editedItem.volume2) + 5
            this.editedItem.volume2 = v+'%'
            }
        },
        deleteItem (item) {
          this.shouldDeleteItem = null
          this.shouldDeleteItem = item
          this.deleteDialog = true
        },
        confirmDelete(){
          const index = this.dayParts.indexOf(this.shouldDeleteItem)
          axios.delete('schedule-setting/'+this.shouldDeleteItem.id+'?token='+this.$store.getters.getToken)
            .then(response=>{
              this.dayParts.splice(index, 1)
              if(this.dayParts.length == 1){
                this.dayParts.splice(0,1)
              }
              this.$store.dispatch('setAlert', response.data.message)
              this.deleteDialog = false
            })
            .catch(error=>{
                this.$store.dispatch('setErrorAlert', error.response.data.message)
            })
        },
        deleteDialogClose(){
          this.shouldDeleteItem=null
          this.deleteDialog = false
        },
        copyToAllDays(){
          this.selectedSchedule = this.selectedSchedule?this.selectedSchedule:this.$store.getters.getNewScheduleId
          axios.post('schedule-setting-copy/'+this.selectedSchedule+'/'+this.dow+'?token='+this.$store.getters.getToken)
              .then(response=>{
                this.$store.dispatch('setAlert', response.data.message)
                this.getScheduleSettings(this.selectedSchedule)
              })
              .catch(error=>{
                  this.$store.dispatch('setErrorAlert', error.response.data.message)
              })
        },
    },
    computed:{
      headers(){ 
        let header =[]
        if(this.$vuetify.breakpoint.smAndDown){
          header = [
            { text: 'Time', value: 'start_time', sortable: false },
            { text: 'Channel', value: 'name', sortable: false },
            { text: 'Volume', value: 'volume', sortable: false },
            { text: 'Playlist', value: 'playlist_name', sortable: false},
            { text: 'Volume', value: 'volume2', sortable: false},
            { text: 'Actions', value: 'action', sortable: false },
          ]
        }else{
         header= [
            {
              text: 'Day Part',
              align: 'left',
              sortable: false,
              value: 'day_part',
              width: '15%'
            },
            { text: 'Time', value: 'start_time', sortable: false, width: '10%'},
            { text: 'Channel', value: 'name', sortable: false },
            { text: 'Volume', value: 'volume', sortable: false, width:'10%'},
            { text: 'Playlist', value: 'playlist_name', sortable: false, width: '15%'},
            { text: 'Volume', value: 'volume2', sortable: false, width: '12%'},
            { text: 'Actions', value: 'action', sortable: false, width: '7%'},
          ]
        }
        return header
      }
    },
    components:{
        VueTimepicker,
    },
    created(){
    }
}
</script>